import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Modal, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getExportLoading } from '../header/header-reducer';
import { getImportLoading, getTotalCount } from './templates-selector';
import { cleanImportLayout, importFile } from './templates-actions';
import { showErrorNotification, showSuccessNotification } from 'libs/util/src/lib/notifications';
import { fetchResourceCleanupDetails } from '../ResourceCleanup/resources-action';

const { Dragger } = Upload;

export const UploadModal = ({ visible, data, onCancel, type }) => {
  const dispatch = useDispatch();
  const isExportLoading = useSelector(getExportLoading);
  let isImportLoading = useSelector(getImportLoading) ? true : data?.length ? true : false;
  let totalCount = useSelector(getTotalCount);

  const handleChanges = (options: any) => {
    const format = options?.file?.name?.split('.').pop();
    if (!(format == 'xlsx' || format === 'xls')) {
      showErrorNotification('Incorrect file format. Only .xlsx and .sls files are supported');
    } else {
      if (options?.file?.status !== 'removed') {
        dispatch(importFile({ file: options.file }, type));
      }
    }
  };

  useEffect(() => {
    if (totalCount === 0 && type == 'Resource cleanup') {
      onCancel();
      showSuccessNotification('File uploaded successfully');
      dispatch(cleanImportLayout());
      dispatch(fetchResourceCleanupDetails(''));
    }
  }, [totalCount]);

  return (
    <StyledImportModal title='Upload Template' visible={visible} footer={null} onCancel={onCancel}>
      <Dragger
        disabled={isImportLoading || isExportLoading}
        accept={'.xlsx, .xlsm'}
        maxCount={1}
        beforeUpload={() => false}
        fileList={[]}
        onChange={handleChanges}
      >
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        {isImportLoading ? (
          <p className='ant-upload-hint'>Processing...</p>
        ) : (
          <>
            <p className='ant-upload-text'>Click or drag file to this area to upload</p>
            <p className='ant-upload-hint'>Support for a single file only</p>
          </>
        )}
      </Dragger>
    </StyledImportModal>
  );
};

const StyledImportModal = styled(Modal)`
  .ant-modal-content {
    width: initial;
  }
`;
